// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb-title {
	font-size: 20px;
	/* border-right: 1.5px solid #aaa4a4 */
}
.breadcrumb-item{
	font-size: 20px !important;
	color: var(--color-text-dark);
}

.page-breadcrumb .breadcrumb li.breadcrumb-item {
	font-size: 16px
}

.page-breadcrumb .breadcrumb-item+.breadcrumb-item::before {
	display: inline-block;
	padding-right: .5rem;
	color: var(--color-icon-muted);
	/* font-family: LineIcons;
	content: "\\ea5c" */
}
.breadcrumb-title i {
	color:var(--color-text-dark) ;
}
.breadcrumb-title a{
	color:var(--color-text-dark);
	text-decoration: none;
}

.breadcrumb {
	margin-bottom: 0.5rem;
	margin-left:0.5rem;
}
@media (max-width: 768px) {
  .page-breadcrumb.breadcrumb-title {
    display: flex !important;
    white-space: normal !important;
    overflow: hidden;
	margin-top: 50px;
  }

  .page-breadcrumb .breadcrumb-item {
    font-size: 18px !important;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.breadcrumb-item.active {
	color: var(--color-text-dark) !important;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/Breadcrumbs.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,sCAAsC;AACvC;AACA;CACC,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,oBAAoB;CACpB,8BAA8B;CAC9B;mBACkB;AACnB;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,4BAA4B;CAC5B,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;AACA;EACE;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,gBAAgB;CACnB,gBAAgB;EACf;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;AACF;AACA;CACC,wCAAwC;AACzC","sourcesContent":[".breadcrumb-title {\r\n\tfont-size: 20px;\r\n\t/* border-right: 1.5px solid #aaa4a4 */\r\n}\r\n.breadcrumb-item{\r\n\tfont-size: 20px !important;\r\n\tcolor: var(--color-text-dark);\r\n}\r\n\r\n.page-breadcrumb .breadcrumb li.breadcrumb-item {\r\n\tfont-size: 16px\r\n}\r\n\r\n.page-breadcrumb .breadcrumb-item+.breadcrumb-item::before {\r\n\tdisplay: inline-block;\r\n\tpadding-right: .5rem;\r\n\tcolor: var(--color-icon-muted);\r\n\t/* font-family: LineIcons;\r\n\tcontent: \"\\ea5c\" */\r\n}\r\n.breadcrumb-title i {\r\n\tcolor:var(--color-text-dark) ;\r\n}\r\n.breadcrumb-title a{\r\n\tcolor:var(--color-text-dark);\r\n\ttext-decoration: none;\r\n}\r\n\r\n.breadcrumb {\r\n\tmargin-bottom: 0.5rem;\r\n\tmargin-left:0.5rem;\r\n}\r\n@media (max-width: 768px) {\r\n  .page-breadcrumb.breadcrumb-title {\r\n    display: flex !important;\r\n    white-space: normal !important;\r\n    overflow: hidden;\r\n\tmargin-top: 50px;\r\n  }\r\n\r\n  .page-breadcrumb .breadcrumb-item {\r\n    font-size: 18px !important;\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n}\r\n.breadcrumb-item.active {\r\n\tcolor: var(--color-text-dark) !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
